import React from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { FormattedMessage } from "react-intl";
import { fields } from "../../common/lib/redux-fields";
import { setField } from "../../common/lib/redux-fields/actions";
import { ValidationError } from "../../common/lib/validation";
import { hashFromObj } from "../../common/lib/utils/hash";

import {
  Container,
  Row,
  Col,
  Form as BootstrapForm,
  FormGroup,
  Label,
  FormFeedback,
  Button
} from "reactstrap";

import { create, get, update, createImage } from "../../common/article/actions";
import {
  clearError,
  clearForm,
  clearFormPreview
} from "../../common/article/actions";

import ButtonWithLoader from "../../browser/components/Form/ButtonWithLoader";
import Input from "../../browser/components/Form/Input";
import Dropzone from "../../browser/components/Form/Dropzone";
import Wysiwyg from "../../browser/components/Form/Wysiwyg";

import moment from "moment";

moment.locale("pl");

const formFields = [
  "title",
  "author",
  "isVisible",
  "isSent",
  "imageFileUid",
  "imageAlt",
  "tag",
  "seoDesc",
  "shortDesc",
  "mainDesc",
  "addedAt"
];

const formPath = "articleForm";

class Form extends React.Component {
  constructor() {
    super();

    this.create = this.create.bind(this);
    this.update = this.update.bind(this);
    this.clearError = this.clearError.bind(this);
    this.onDrop = this.onDrop.bind(this);
    this.clearDropzone = this.clearDropzone.bind(this);
  }

  componentDidMount() {
    const {
      params,
      get,
      editForm,
      fields,
      clearForm,
      clearFormPreview
    } = this.props;

    fields.$reset();
    clearForm();
    clearFormPreview();
  }

  redirect(to) {
    const { router } = this.context;
    // so that folks can unit test w/o hassle
    if (router) router.transitionTo(to);
  }

  async create(e) {
    const { fields, appPath } = this.props;
    const { create } = this.props;
    e.preventDefault();
    const values = fields.$values();

    const rs = await create(values);

    if (rs && rs.status === 200) {
      fields.$reset();
      this.redirect(`${appPath}/articles/edit/${rs.body.uid}`);
    }
  }

  async update(e) {
    const { fields, params } = this.props;
    const { update, get, clearForm } = this.props;
    e.preventDefault();
    const values = fields.$valuesChanged();

    if (Object.keys(values).length > 0) {
      values.uid = params.uid;

      const rs = await update(values);

      if (rs && (rs.status === 200 || rs.status === 204)) {
        await get({ uid: params.uid });
        fields.$reset();
      }
    }
  }

  async onDrop(files) {
    const { createImage, setField } = this.props;

    this.clearError("imageFileUid");

    const status = await createImage(files);
    setField([formPath, "imageFileUid"], status.body.uid);
  }

  clearDropzone(e) {
    const { fields, params, clearFormPreview } = this.props;

    e.stopPropagation();

    fields.$setValue("imageFileUid", "");
    clearFormPreview();
  }

  clearError(field) {
    const { clearError } = this.props;

    clearError(field);
  }

  render() {
    const { apiHost, fields, form, editForm, obj } = this.props;

    const dirty = Object.keys(fields.$valuesChanged()).length > 0;

    let imageFileUid = null;

    if (editForm) {
      imageFileUid = fields.imageFileUid.value;
    }

    return (
      <BootstrapForm onSubmit={editForm ? this.update : this.create} noValidate>
        <Container>
          <Row>
            <Col xs="6">
              <Input
                field="title"
                title="Tytuł"
                type="text"
                loading={form.get("loading")}
                error={form.get("error")}
                clearError={this.clearError.bind(this, "title")}
                formPath={formPath}
                {...fields.title}
              />
              <Dropzone
                field="imageFileUid"
                title="Obrazek"
                loading={form.get("fileLoading")}
                error={form.get("error")}
                clearError={this.clearError.bind(this, "imageFileUid")}
                placeholder="Przeciągnij obrazek tutaj, lub kliknij, aby wybrać plik"
                preview={
                  form.get("filePreview") ? (
                    form.get("filePreview")
                  ) : imageFileUid ? (
                    apiHost + "/v1/article/image/" + imageFileUid
                  ) : null
                }
                onDrop={this.onDrop}
                onDelete={this.clearDropzone}
              />
              <Input
                field="addedAt"
                title="Data dodania"
                type="date"
                loading={form.get("loading")}
                error={form.get("error")}
                clearError={this.clearError.bind(this, "addedAt")}
                formPath={formPath}
                {...fields.addedAt}
              />
            </Col>
            <Col xs="6">
              <Input
                field="author"
                title="Autor"
                type="text"
                loading={form.get("loading")}
                error={form.get("error")}
                clearError={this.clearError.bind(this, "author")}
                formPath={formPath}
                {...fields.author}
              />
              <Input
                field="tag"
                title="Tag"
                type="select"
                loading={form.get("loading")}
                error={form.get("error")}
                clearError={this.clearError.bind(this, "tag")}
                formPath={formPath}
                {...fields.tag}
              >
                <option>Choroby</option>
                <option>Dieta</option>
                <option>Nauka</option>
                <option>Płace</option>
                <option>Praca</option>
                <option>Zdrowie</option>
              </Input>
              <Input
                field="imageAlt"
                title="Opis obrazka"
                type="text"
                loading={form.get("loading")}
                error={form.get("error")}
                clearError={this.clearError.bind(this, "imageAlt")}
                formPath={formPath}
                {...fields.imageAlt}
              />
              <Input
                field="isVisible"
                title="Czy widoczny"
                type="checkbox"
                loading={form.get("loading")}
                error={form.get("error")}
                checked={fields.isVisible.value}
                clearError={this.clearError.bind(this, "isVisible")}
                formPath={formPath}
                {...fields.isVisible}
              />
              <Input
                field="isSent"
                title="Czy był wysłany w newsletterze?"
                type="checkbox"
                loading={form.get("loading")}
                error={form.get("error")}
                checked={fields.isSent.value}
                clearError={this.clearError.bind(this, "isSent")}
                formPath={formPath}
                {...fields.isSent}
              />
            </Col>
            <Col xs="6">
              <Input
                field="shortDesc"
                title="Krótki opis"
                type="textarea"
                loading={form.get("loading")}
                error={form.get("error")}
                clearError={this.clearError.bind(this, "shortDesc")}
                formPath={formPath}
                {...fields.shortDesc}
                rows="2"
              />
            </Col>
            <Col xs="6">
              <Input
                field="seoDesc"
                title="Opis SEO"
                type="textarea"
                loading={form.get("loading")}
                error={form.get("error")}
                clearError={this.clearError.bind(this, "seoDesc")}
                formPath={formPath}
                {...fields.seoDesc}
                rows="2"
              />
            </Col>
            <Col xs="12">
              <Wysiwyg
                field="mainDesc"
                className="text-wysiwyg form-input col-xs-12"
                title="Treść"
                type="textarea"
                formPath={formPath}
                loading={form.get("loading")}
                error={form.get("error")}
                clearError={this.clearError.bind(this, "mainDesc")}
                {...fields.mainDesc}
                rows="6"
              />
            </Col>
            <ButtonWithLoader
              className="button-loader"
              size="lg"
              color={dirty ? "warning" : "success"}
              text={editForm ? "Zapisano" : "Wprowadź dane"}
              isLoading={form.get("loading") || form.get("fileLoading")}
              loadingText={"Zapisuję zmiany..."}
              isDirty={dirty}
              dirtyText={editForm ? "Zapisz zmiany" : "Dodaj ofertę"}
            />
          </Row>
        </Container>
      </BootstrapForm>
    );
  }
}

Form.contextTypes = {
  router: React.PropTypes.object.isRequired
};

Form = fields(Form, {
  path: formPath,
  fields: formFields,
  getInitialState: ({ obj, editForm }) => {
    return {
      title: editForm ? obj.get("title") : "",
      author: editForm ? obj.get("author") : "",
      isVisible: editForm ? obj.get("isVisible") : false,
      isSent: editForm ? obj.get("isSent") : false,
      imageFileUid: editForm ? obj.get("imageFileUid") : "",
      imageAlt: editForm ? obj.get("imageAlt") : "",
      tag: editForm ? obj.get("tag") : "",
      seoDesc: editForm ? obj.get("seoDesc") : "",
      shortDesc: editForm ? obj.get("shortDesc") : "",
      mainDesc: editForm ? obj.get("mainDesc") : "",
      addedAt: editForm ? obj.get("addedAt") : moment().toISOString()
    };
  }
});

Form = connect(
  state => ({
    apiHost: state.config.apiHost,
    form: state.article.form,
    fields: state.fields,
    appPath: state.config.appPath
  }),
  {
    create,
    createImage,
    clearError,
    clearForm,
    clearFormPreview,
    get,
    update,
    setField
  }
)(Form);

export { Form, formFields };



// WEBPACK FOOTER //
// ./src/browser/article/Form.js